import styled from 'styled-components';

export const Container = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Title = styled.h3`
  margin: 0 0 1rem 0;
`;

export const Subtitle = styled.p`
  margin: 0 0 2rem 0;
`;
